export default "__VITE_ASSET__aic9PkK$__"